import { Button } from 'components/shared'
import { classNameJoin } from 'utils/lib'

interface StepButtonProps {
    step: number
    isNextPossible: boolean
    onClickNext: () => void
    onClickPrev: () => void
    isLoading?: boolean
}

export const StepButton = ({
    isLoading,
    step,
    isNextPossible,
    onClickNext,
    onClickPrev,
}: StepButtonProps) => {
    return (
        <div className="flex flex-row gap-2 w-full h-[clamp(44px,3vw,52px)]">
            {step > 0 && (
                <button
                    className={classNameJoin([
                        'rounded-[12px] w-[20%] h-full bg-[#F2F2F2]',
                        'text-[clamp(16px,3vw,20px)] text-[#565656] font-bold',
                    ])}
                    onClick={onClickPrev}
                >
                    이전
                </button>
            )}
            <Button
                loading={isLoading}
                className={classNameJoin([
                    `${isNextPossible ? 'bg-[#F52388]' : 'bg-[#00000012]'}`,
                    `text-[clamp(16px,3vw,20px)] font-bold rounded-[12px] flex-1 h-full`,
                    `${isNextPossible ? 'text-[#FDE8F2]' : 'text-[#B1B1B1]'}`,
                ])}
                disabled={!isNextPossible}
                onClick={onClickNext}
            >
                {step === 2 ? '가입 신청하기' : '다음'}
            </Button>
        </div>
    )
}
